import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import FullScreenButton from '@components/fullScreenButton';
import { FixedRatioSectionWrapper } from '@components/fixedRatioContainer';
import './styles.scss';

const FullScreenElemId = 'iframe-pdf-container';

// link example: https://pwc.sharepoint.com/:w:/r/sites/US-ADV-SolutionInnovations/_layouts/15/Doc.aspx?sourcedoc=%7BD7F2BE9C-5793-42F7-9E33-626F2F30FC46%7D&file=Guide%20to%20migrate%20repos%20from%20github.pwc.com%20to%20Azure%20Repo.docx&action=default&mobileredirect=true&DefaultItemOpen=1&login_hint=xue.z.zhang%40pwc.com&ct=1687338417875&wdOrigin=OFFICECOM-WEB.START.EDGEWORTH&cid=c957a622-00e9-4222-b98e-7c11ab8cbfc1&wdPreviousSessionSrc=HarmonyWeb&wdPreviousSession=5d87390b-8c1a-4618-b920-5b4e2e4cf7c9

export const validateM365URL = function (link) {
  if (!link) {
    return false;
  }
  try {
    const url = new URL(link);
    if (url.host !== 'pwc.sharepoint.com') {
      return false;
    }
    if (!url.searchParams.has('sourcedoc')) {
      return false;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
  return true;
};

function SharePointIframe({ link }) {
  const [embedLink, setEmbedLink] = useState('');

  const generateEmbeddedLink = useCallback(
    (link) => {
      if (!link) {
        return '';
      }
      try {
        const url = new URL(link);
        const searchParams = url.searchParams;
        const requiredParams = ['sourcedoc', 'id', 'listurl', 'parentview'];
        // TODO validate required params

        const newURL = new URL(url.origin + url.pathname);
        requiredParams.forEach((key) => {
          const value = searchParams.get(key);
          if (value) {
            newURL.searchParams.append(key, value);
          }
        });
        newURL.searchParams.append('action', 'embedview');
        // newURL.searchParams.append('wdAr', '1.7777777777777777');

        setEmbedLink(newURL.toString());
      } catch (e) {
        console.log(e);
      }
    },
    [link],
  );

  useEffect(() => {
    generateEmbeddedLink(link);
  }, [link]);

  return embedLink ? (
    <iframe className="external-iframe" src={embedLink} />
  ) : null;
}

export default React.memo(SharePointIframe);
